import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initMetaPixel, meta } from "./metaPixel";

export default function MetaPixelRouter() {
  const location = useLocation();

  useEffect(() => {
    initMetaPixel();
  }, []);

  useEffect(() => {
    meta.pageView();
  }, [location.pathname, location.search]);

  return null;
}
